import { render, staticRenderFns } from "./indexAdd.vue?vue&type=template&id=b34b7b04&scoped=true"
import script from "./indexAdd.vue?vue&type=script&lang=js"
export * from "./indexAdd.vue?vue&type=script&lang=js"
import style0 from "./indexAdd.vue?vue&type=style&index=0&id=b34b7b04&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34b7b04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b34b7b04')) {
      api.createRecord('b34b7b04', component.options)
    } else {
      api.reload('b34b7b04', component.options)
    }
    module.hot.accept("./indexAdd.vue?vue&type=template&id=b34b7b04&scoped=true", function () {
      api.rerender('b34b7b04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/webSet/competition/indexAdd.vue"
export default component.exports